export default __webpack_public_path__ + "static/media/Logo_WithRays.a731e565.png";